import { ChangeEvent, useEffect, useRef, useState } from 'react'
import {
  BoardListItem,
  getBadgeLabel,
  getMobileBadgeClass,
  TInput,
  withDrawnCumtomer,
} from '../boardItem'
import { InquiryDetailInfo } from './inquiryDetailInfo'
import { useResponsive } from '@/hooks/useResponsive'
import { useLocation, useNavigate } from 'react-router-dom'
import commonUtils from '@/utils/commonUtils'
import { useAppSelector } from '@/redux/hooks'

interface DetailContentsProps {
  boardDetail: BoardListItem | null
  height: string
  handleChange: (e: React.ChangeEvent<TInput>) => void
  isGuest: boolean
  scrollToComment: () => void
  handleCopy: () => void
  isMobile: boolean
  handleModalAction: (type: 'update' | 'delete' | 'cancel') => void
}

export const InquiryDetailContents: React.FC<DetailContentsProps> = ({
  boardDetail,
  height,
  handleChange,
  isGuest,
  scrollToComment,
  handleCopy,
  isMobile,
  handleModalAction,
}) => {
  const navigate = useNavigate()
  const textareaRef = useRef<HTMLTextAreaElement>(null)
  const [isEditMode, setIsEditMode] = useState(false)
  const { user } = useAppSelector((state) => state.auth)
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0) // behavior: 'smooth' 없이 즉시 이동
  }, [])

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto' // 높이 초기화
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px` // 새로운 높이 설정
    }
  }, [boardDetail?.nttCn]) // boardDetail.NTT_CN이 변경될 때마다 실행

  const handleInputChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const textarea = e.target
    textarea.style.height = 'auto' // 높이 초기화
    textarea.style.height = `${textarea.scrollHeight}px` // 새로운 높이 설정
    handleChange(e) // 부모 컴포넌트의 handleChange 호출
  }

  return (
    <>
      {!isMobile ? (
        <>
          <div
            style={{
              fontSize: '20px',
              fontWeight: '600',
              whiteSpace: 'pre-wrap', // 자동 줄바꿈
              wordWrap: 'break-word', // 긴 단어 줄바꿈
              overflow: 'hidden',
              marginBottom: '5px',
              marginTop: '5px',
            }}
          >
            {boardDetail?.nttSj}
          </div>
          <InquiryDetailInfo
            isGuest={isGuest}
            boardDetail={boardDetail}
            scrollToComment={scrollToComment}
            handleCopy={handleCopy}
          />
          <div
            style={{
              boxShadow: '0 0 0 0.5px #ebecef',
              borderColor: '#ebecef',
              marginTop: '10px',
              marginBottom: '10px',
            }}
          />
          <div
            style={{
              marginBottom: '10px',
              border: 'none',
              borderRadius: '4px',
              padding: '20px 0',
            }}
          >
            <textarea
              ref={textareaRef}
              id="nttCn"
              name="nttCn"
              value={
                boardDetail?.withDrawYn === 'Y'
                  ? withDrawnCumtomer.contents
                  : boardDetail?.nttCn
              }
              onChange={handleInputChange}
              style={{
                width: '100%',
                height: '400px',
                border: 'none',
                outline: 'none',
                borderRadius: '4px',
                resize: 'none',
                backgroundColor: 'transparent',
              }}
            />
          </div>
        </>
      ) : (
        <div className="mobile-view">
          <div className="mobile-post-detail-container">
            <div className="mobile-post-detail-header">
              <h1
                className="mobile-post-detail-title"
                onClick={() => {
                  navigate(`/inquiry`)
                }}
              >
                문의
              </h1>
              <button className="mobile-url-copy-btn" onClick={handleCopy}>
                URL복사
              </button>
            </div>
            <div className="mobile-post-card" key={boardDetail?.nttSn}>
              <div className="mobile-post-card-header">
                <span
                  className={getMobileBadgeClass(boardDetail?.bbsSj || '00')}
                >
                  {getBadgeLabel(boardDetail?.bbsSj ?? '기타')}
                </span>
                <h2 className="mobile-post-card-title">{boardDetail?.nttSj}</h2>
                <div className="mobile-post-card-meta">
                  <div className="mobile-post-card-meta-row">
                    <span>
                      {boardDetail?.withDrawYn === 'Y'
                        ? withDrawnCumtomer.name
                        : isGuest
                          ? boardDetail?.guestName
                          : boardDetail?.nickName}
                      &nbsp; ({boardDetail?.accessIp})
                    </span>
                    <span>views {boardDetail?.readngCnt}</span>
                  </div>
                  <div className="mobile-post-card-meta-row">
                    <span>
                      {boardDetail?.regDate
                        ? commonUtils.formatDate(boardDetail.regDate, true)
                        : ''}
                    </span>
                  </div>
                </div>
              </div>
              <div className="mobile-post-card-content">
                {boardDetail?.withDrawYn === 'Y'
                  ? withDrawnCumtomer.contents
                  : boardDetail?.nttCn}
              </div>
            </div>
            {boardDetail?.replyYn === 'Y' && (
              <div className="mobile-answer-section">
                <div className="mobile-answer-header">
                  <div className="mobile-answer-badge">답변완료</div>
                  <div className="mobile-answer-timestamp">
                    {boardDetail?.replyRegDate
                      ? commonUtils.formatDate(boardDetail?.replyRegDate, true)
                      : ''}
                  </div>
                  <div className="mobile-answer-greeting">
                    {boardDetail?.replyCn}
                  </div>
                </div>
              </div>
            )}
            <div className="mobile-post-actions">
              <button
                className="mobile-action-btn primary"
                onClick={() => navigate(`/inquiry`, { state: location.state })}
              >
                목록으로
              </button>
              {(user?.userId === boardDetail?.regId ||
                user?.cstId === boardDetail?.regId) && (
                <>
                  <button
                    className="mobile-action-btn user"
                    onClick={() => handleModalAction('update')}
                  >
                    수정
                  </button>
                  <button
                    className="mobile-action-btn user"
                    onClick={() => handleModalAction('delete')}
                  >
                    삭제
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
